import { render, staticRenderFns } from "./AddGroupBuySetting.vue?vue&type=template&id=ccc6d296"
import script from "./AddGroupBuySetting.vue?vue&type=script&lang=js"
export * from "./AddGroupBuySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports